export const HeaderData = [
	{
		to: '/',
		text: 'FAQ',
		id: 1,
	},
	{
		to: '/',
		text: 'Оплата и доставка',
		id: 2,
	},
	{
		to: '/',
		text: 'Возврат',
		id: 3,
	},
	{
		to: '/',
		text: 'Исследования',
		id: 4,
	},
	{
		to: '/',
		text: 'Личный кабинет',
		id: 5,
	},


];